/**
 * 应用入口：主题预初始化（防闪烁）→ QueryClient → Router → 会话引导 → PWA SW 注册。
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { useAuth } from './stores/auth';
import { STORAGE_KEYS } from './lib/utils';
import './index.css';

// 主题预初始化：首帧前应用深色类，避免闪白（与 stores/theme 的 lc-theme 约定一致）
(function initTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.theme);
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const isDark = saved === 'dark' || (saved !== 'light' && prefersDark);
    document.documentElement.classList.toggle('dark', isDark);
  } catch {
    /* localStorage 不可用时跟随系统 */
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

// PWA：service worker 自动更新
registerSW({ immediate: true });

// 会话引导（cookie 续签探测），不阻塞首屏渲染
void useAuth.getState().bootstrap();

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
